import { SimpleSignal } from "../utils/SimpleSignal";

export class ViewPreset
{

	private _element:HTMLSelectElement;
	public changeSignal:SimpleSignal;

	constructor()
	{
		this._element = <HTMLSelectElement>document.getElementById("viewPreset");
		this._element.addEventListener("change", this.onChange);

		this.changeSignal = new SimpleSignal();
	}

	private onChange = (event) =>
	{
		var value = this._element.options[ this._element.selectedIndex ].value;

		this.changeSignal.dispatch(value);
	};

	public set value(value)
	{
		var options = this._element.options;

		for (var i = 0; i < options.length; i++)
		{
			if (options[i].value === value)
			{
				this._element.selectedIndex = options[i].index;
				return;
			}
		}
	}
}